var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObj,
    style: ({
      width: _vm.width
    })
  }, [_c('textarea', {
    class: (_vm.prefixCls + "-form-control"),
    style: (_vm.styleObj),
    attrs: {
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "maxlength": _vm.maxLength,
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.update($event.target.value)
      },
      "focus": _vm._onFocus,
      "blur": _vm._onBlur
    }
  }), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-55ee819a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ee819a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Textarea/n3Textarea.vue
// module id = 627
// module chunks = 0 1